import { CustomNavigate } from "@UI/CustomNavigate"
import { Row, Typography } from "antd"
import './styles.css'
import HistoryIcon from "@assets/icons/HistoryIcon"
import ExcelIcon from "@assets/icons/ExcelIcon"
import { useState } from "react"
import useCurrentLocation from "@thooks/useCurrentLocation"
import LogsDrawer from "@tcomponents/Logs/components/LogsDrawer/LogsDrawer"
import { useReceivedPaymentDetailHeader } from "./hooks/useReceivedPaymentDetailHeader"
import FeatureButton from "@tcomponents/FeatureButton/FeatureButton"
import { COLLECTION_ADMINISTRATION_CODES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"

const { Paragraph } = Typography

//A
const ReceivedPaymentDetailHeader = () => {

  const { param, location } = useCurrentLocation()
  const { handleDownloadChargeInstanceData, loadingReceivedPaymentDetail } = useReceivedPaymentDetailHeader()
  const [openLogsDrawer, setOpenLogsDrawer] = useState(false)

  return (
    <header>
      <small className="new-edit-collection-template-subtitle">
        ADMINISTRACIÓN DE COBROS / DETALLES DE PAGOS RECIBIDOS
      </small>
      <CustomNavigate title={
        <Paragraph
          className='new-edit-collection-template-title'
          ellipsis
        >
          {location.state?.currentCharge?.name?.toUpperCase()}
        </Paragraph>
      }>
        <Row className="new-edit-template-collection-header" style={{ gap: 16 }} align="middle">
          <FeatureButton
            code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_EXPORT_DEBTORS_INFO}
            className={'btn-logs-received-payments-disabled btn-standard-white'}
            style={{
              borderRadius: '50%',
              width: 42,
              height: 40,
            }}
            popoverProps={{
              placement: 'bottomRight',
            }}
            tooltip="Exportar datos"
            icon={<ExcelIcon />}
            loading={loadingReceivedPaymentDetail}
            onClick={() => handleDownloadChargeInstanceData({ charge_instance_id: param.chargeInstanceId })}
          />
          <FeatureButton
            code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_CHECK_LOGS_DETAIL_COLLECTION}
            className={'btn-logs-received-payments-disabled btn-standard-white'}
            style={{
              borderRadius: '50%',
              width: 42,
              height: 40,
            }}
            popoverProps={{
              placement: 'bottomRight',
            }}
            tooltip="Historial de cambios"
            icon={<HistoryIcon />}
            loading={loadingReceivedPaymentDetail}
            onClick={() => setOpenLogsDrawer(true)}
          />
          <LogsDrawer
            isOpen={openLogsDrawer}
            onClose={() => setOpenLogsDrawer(false)}
            redirectTo="/logs/administration-collection"
            service="/charge/instance/debtor/log"
            logsParams={{
              charge_instance_id: param.chargeInstanceId
            }}
          />
        </Row>
      </CustomNavigate>
    </header>
  )
}

export default ReceivedPaymentDetailHeader
